<template>
	<div class="register_page">
		<div class="wrap">
			<div class="register_box">
				<h1 class="logo">
					<img src="@/assets/images/logo.png" alt="janopay logo image" />
				</h1>

				<div v-if="step === 0">
					<p class="welcome_text">
						{{ $t('rtr_auth-register.text3') }} <br />
						{{ $t('rtr_auth-register.text4') }}
					</p>
					<p class="term_text pc">
						{{ $t('rtr_auth-register.text5') }}
					</p>
					<div class="box_description">
						<div class="box_check mb_20">
							<label class="checkbox_container fs_14">
								{{ $t('rtr_auth-register.text6') }}
								<input
									type="checkbox"
									id="all_check"
									v-model="allCheck"
									@click="selectAll"
								/>
								<span class="checkmark"></span>
							</label>
						</div>
						<div
							class="box_check"
							v-for="(item, idx) in termList"
							v-bind:key="idx"
						>
							<div class="d_flex justify_between">
								<label v-if="item.display" class="checkbox_container fs_14">
									{{ $t(item.type) }}
									<span class="fc_red">{{
										is_required_mark(item.is_required)
									}}</span>
									<input
										type="checkbox"
										class="list_check_box"
										v-bind:key="item.type"
										v-bind:required="item.is_required"
										v-model="item.checked"
									/>
									<span class="checkmark"></span>
								</label>
								<div @click="showTermsDetail(item)">
									<a class="more">
										{{ $t('rtr_auth-register.show') }}
										<span class="CIRCLE_ARROW"></span>
									</a>
								</div>
							</div>
							<!-- <p v-html="item.content"></p> -->
						</div>
					</div>

					<p class="term_text mobile">
						{{ $t('rtr_auth-register.text5') }}
					</p>

					<div class="button_area mt_30">
						<button
							class="signup_button w100"
							v-on:click="nextStep"
							:disabled="!isAgreeBtnActive"
						>
							{{ $t('rtr_auth-register.agree') }}
						</button>
						<router-link to class="cancel" @click="toHome">{{
							$t('rtr_auth-register.cancel')
						}}</router-link>
					</div>
				</div>

				<div v-if="step === 1">
					<p class="welcome_text mobile">
						{{ $t('rtr_auth-register.text1') }}<br />
						{{ $t('rtr_auth-register.text2') }}
					</p>

					<form class="register_form" autocomplete="off" @submit.prevent>
						<input
							type="text"
							class="required_input mb_10"
							v-model="params.userId"
							:placeholder="$t('rtr_auth-register.id')"
						/>
						<input
							type="email"
							class="required_input mb_10"
							v-model="params.emailAddress"
							:placeholder="$t('rtr_auth-register.email')"
							required
						/>
						<input
							type="text"
							class="required_input mb_10"
							v-model="params.userName"
							:placeholder="$t('rtr_auth-register.userName')"
						/>
						<input
							type="password"
							class="required_input mb_10"
							v-model="params.password"
							:placeholder="$t('rtr_auth-register.password')"
						/>
						<input
							type="password"
							class="required_input"
							v-model="params.confirmPassword"
							:placeholder="$t('rtr_auth-register.rePassword')"
						/>

						<div class="button_area mt_20">
							<button
								type="submit"
								class="signup_button w100"
								:disabled="!isBtnActive"
								@click="registerForm"
							>
								{{ $t('rtr_auth-register.signUp') }}
							</button>
							<router-link to class="cancel" @click="toHome">{{
								$t('rtr_auth-register.cancel')
							}}</router-link>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
	<ModalViewM
		v-if="showTerms"
		@closeModal="showTerms = false"
		add-class="register_list"
	>
		<TermsContent
			:terms="selectedTerms"
			@close="showTerms = false"
			@agreeTerms="agreeTerms"
		></TermsContent>
	</ModalViewM>
	<ModalMessageM v-if="successModal" @closeModal="successModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="mb_40">{{ modalStatusMessage }}</p>
		<div class="button_area">
			<button class="button_bg_red button_m" @click="onConfirm">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessageM>
</template>

<script>
import ModalViewM from '@/components/Layout/ModalView.m';
import { newMember } from '@/api/member';
// import { fetchServiceConfig } from '@/api/config';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import TermsContent from '@/components/Auth/TermsContent';
export default {
	name: 'Register.m',
	components: { ModalViewM, ModalMessageM, TermsContent },
	data() {
		return {
			params: {
				userId: '',
				password: '',
				confirmPassword: '',
				userName: '',
				emailAddress: '',
				inviterIdentifier: '',
			},
			terms: [],
			step: 1,
			allCheck: false,
			isBtnActive: false,
			showTerms: false,
			successModal: false,
			registerStatus: '',
			modalStatusMessage: this.$t('rtr_auth-register.success'),
			modalIcon: 'success',
			isSuccess: false,
			selectedTerms: {},
			termList: [
				{
					checked: false,
					is_required: 'Y',
					display: 'N',
					type: 'terms.menu.title24',
					number: 1,
				},
				{
					checked: false,
					is_required: 'Y',
					display: 'N',
					type: 'terms.menu.title25',
					number: 2,
				},
				{
					checked: false,
					is_required: 'Y',
					display: 'N',
					type: 'terms.menu.title26',
					number: 3,
				},
				{
					checked: false,
					is_required: 'N',
					display: 'N',
					type: 'terms.menu.category1',
					number: 4,
				},
				{
					checked: false,
					is_required: 'N',
					display: 'N',
					type: 'terms.menu.category2',
					number: 5,
				},
				{
					checked: false,
					is_required: 'N',
					display: 'N',
					type: 'terms.menu.category3',
					number: 6,
				},
			],
		};
	},
	computed: {
		isTermsAllCheck() {
			let check = true;
			this.termList.forEach(item => {
				if (!item.checked) {
					check = false;
					return false;
				}
			});
			return check;
		},
		isAgreeBtnActive() {
			let check = true;
			this.termList.forEach(item => {
				if (item.is_required === 'Y' && !item.checked) {
					check = false;
					return false;
				}
			});
			return check;
		},
	},
	watch: {
		isTermsAllCheck() {
			this.allCheck = this.isTermsAllCheck;
		},
		params: {
			handler() {
				const requiredInput = Array.prototype.slice.call(
					document.getElementsByClassName('required_input'),
				);
				const isAllEntered = item => item.value.length > 0;
				if (requiredInput.every(isAllEntered)) this.isBtnActive = true;
				else this.isBtnActive = false;
			},
			deep: true,
		},
	},
	methods: {
		// getTerms() {
		// 	fetchServiceConfig().then(({ config }) => {
		// 		config.terms.forEach(item => {
		// 			item.checked = false;
		// 		});
		// 		this.terms = config.terms;
		// 	});
		// },
		nextStep() {
			this.step++;
		},
		selectAll() {
			this.termList.forEach(item => {
				item.checked = !this.allCheck;
			});
		},
		async registerForm() {
			const memberInfo = {
				user_id: this.params.userId,
				password: this.params.password,
				confirm_password: this.params.confirmPassword,
				user_name: this.params.userName,
				email_address: this.params.emailAddress,
				inviter_identifier: this.params.inviterIdentifier,
			};
			await newMember(memberInfo)
				.then(() => {
					this.modalStatusMessage = this.$t('rtr_auth-register.success');
					this.modalIcon = 'success';
					this.successModal = true;
					this.isSuccess = true;
				})
				.catch(err => {
					this.modalStatusMessage = err.message;
					this.modalIcon = 'error';
					this.successModal = true;
					this.isSuccess = false;
				});
		},
		initForm() {
			this.params.userId = '';
			this.params.password = '';
			this.params.confirmPassword = '';
			this.params.userName = '';
			this.params.emailAddress = '';
			this.params.inviterIdentifier = '';
			this.step--;
		},
		is_required_mark(value) {
			if (value === 'Y') return this.$t('rtr_auth-register.required');
			else return '';
		},
		onConfirm() {
			if (this.isSuccess) {
				this.toLogin();
			} else {
				this.successModal = false;
			}
		},
		toHome() {
			this.$router.push({ name: 'home' });
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
		showTermsDetail(terms) {
			this.selectedTerms = terms;
			this.showTerms = true;
		},
		agreeTerms(term) {
			this.termList.find(item => {
				return item.type === term.type;
			}).checked = true;
			this.showTerms = false;
		},
	},
	// created() {
	// 	this.getTerms();
	// },
};
</script>
